import React from 'react';
import PaidSearchDoubleOptionBarChart from '../PaidSearchDoubleOptionBarChart';
import PaidSearchKeyMetricCards from '../PaidSearchKeyMetricCards';
import AdvertisingMultiMetricTrendChart from '../AdvertisingMultiMetricTrendChart';
import PaidSearchGrid from '../PaidSearchGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  BEACON_CHART_SPACING,
  BEACON_PRO_PAGE_MARGIN_BOTTOM
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import { isTopicOrTopicGroupType } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils';
import { NonTopicOrTopicGroupPage } from './NonTopicOrTopicGroupPage';
import { TopicOrTopicGroupPage } from './TopicOrTopicGroupPage';
import { PaidSearchMetricProvider } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/PaidSearch/PaidSearchMetricContext';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Traffic paid search tab
 */
export default function PaidSearchPage() {
  const entityType = useMainEntityType();

  if (shouldShowBeaconProTopics() && isTopicOrTopicGroupType(entityType)) {
    return <TopicOrTopicGroupPage />;
  }

  if (shouldShowBeaconProTopics() && !isTopicOrTopicGroupType(entityType)) {
    return <NonTopicOrTopicGroupPage />;
  }

  return (
    <Flex flexDirection="column" gap={BEACON_CHART_SPACING} marginBottom={BEACON_PRO_PAGE_MARGIN_BOTTOM}>
      <PaidSearchMetricProvider>
        <PaidSearchKeyMetricCards />
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_BAR_CHART.name}
          chartName={CHART_NAMES.BEACON_PAID_SEARCH_BAR_CHART_COLUMN}
        >
          <PaidSearchDoubleOptionBarChart />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_TREND_CHART.name}
          chartName={CHART_NAMES.BEACON_PAID_SEARCH_TREND_CHART_SPLINE}
        >
          <AdvertisingMultiMetricTrendChart />
        </ChartContextProvider>
      </PaidSearchMetricProvider>

      <PaidSearchGrid />
    </Flex>
  );
}
